// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__291yn","errorLogs":"EditorFooter_errorLogs__28FMx"};